import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

export class ListLayout extends Component {

  render() {
    const separator = this.props.separator ? "separator-item" : "";

    const wrapped_childs = React.Children.map(this.props.children, (child) => {
      const clone = React.cloneElement(child, {});
        return (
          <Col xs="12" className={separator}>
            { clone }
          </Col>
        );
      });

    const { noGutters } = this.props;

    return (
      <Row noGutters={noGutters}>
        { wrapped_childs }
      </Row>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/layout/ListLayout.js